import { useState, useEffect } from 'react';
import { GetProducerIDsFromNPN } from '../../../../../api/regedint';
import { useQuery } from '@tanstack/react-query';
import { useUser } from '../../../../../context/UserContext';
import { MenuItem, FormControl, Select, TextField, InputLabel } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export default function ProducerDropdown({ ...props }) {
  const user = useUser();

  const [searchParams, setSearchParams] = useSearchParams();
  const initialProducerID = searchParams.get('producerID');
  const [producerID, setProducerID] = useState(initialProducerID ?? '');

  const updateParams = (newParams) => {
    const updatedParams = new URLSearchParams(searchParams);
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        updatedParams.set(key, value);
      } else {
        updatedParams.delete(key);
      }
    });
    setSearchParams(updatedParams);
  };

  const getProducerIDsFromNPN = useQuery({
    queryKey: ['GetProducerIDsFromNPN', user.npnID],
    queryFn: () => GetProducerIDsFromNPN({ NPN: user.npnID, Status: '', State: '' })(),
    enabled: user != null,
  });

  useEffect(() => {
    if (getProducerIDsFromNPN.isSuccess && getProducerIDsFromNPN.data) {
      setProducerID(props.defaultValue ? props.defaultValue : user.producerID.split(',')[0]);
      updateParams({
        producerID: props.defaultValue ? props.defaultValue : user.producerID.split(',')[0],
      });

      if (getProducerIDsFromNPN.data != null && props.setIsVisible !== undefined)
        props.setIsVisible(getProducerIDsFromNPN.data.length > 1);
    }
  }, [getProducerIDsFromNPN.isSuccess, getProducerIDsFromNPN.data]);

  if (
    getProducerIDsFromNPN.isFetching ||
    getProducerIDsFromNPN.isPending ||
    getProducerIDsFromNPN.isIdle
  )
    return null;

  if (user.npnID === 'HO') {
    return (
      <TextField
        defaultValue={producerID}
        id="producerID-input-field"
        label="Producer ID"
        required
        error={props.error}
        helperText={props.helperText}
        value={producerID}
        onChange={(event) => {
          setProducerID(event.target.value);
          updateParams({ producerID: event.target.value });
          props.setProducerID(event.target.value);
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: 'darkslateblue',
          },
        })}
      />
    );
  }

  if (getProducerIDsFromNPN.data != null && getProducerIDsFromNPN.data.length <= 1) return null;

  return (
    <FormControl
      id="getProducerIDsFromNPN-select"
      key="getProducerIDsFromNPN-select"
      sx={props.formControlStyling ? props.formControlStyling : null}
      disabled={
        getProducerIDsFromNPN.isFetching ||
        getProducerIDsFromNPN.isPending ||
        getProducerIDsFromNPN.isIdle
      }
      className="exit-swipe-left"
    >
      <InputLabel id="issued-pdfs-producer-label">Producer IDs</InputLabel>
      <Select
        defaultValue={producerID}
        labelId="issued-pdfs-producer-label"
        label="Producer IDs"
        id="getProducerIDsFromNPN-simple-select"
        value={producerID}
        variant={props.variant}
        sx={{
          minWidth: 130,
        }}
        onChange={(event) => {
          setProducerID(event.target.value);
          updateParams({ producerID: event.target.value });
          props.setProducerID(event.target.value);
        }}
      >
        {getProducerIDsFromNPN.data != null &&
          getProducerIDsFromNPN.data.map((pr, i) => (
            <MenuItem
              style={{ display: 'block', padding: '0.5em 1em' }}
              key={pr + '-' + i}
              value={pr}
            >
              {pr}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
